import { render, staticRenderFns } from "./MDMail.vue?vue&type=template&id=f5ba44de&scoped=true"
import script from "./MDMail.vue?vue&type=script&lang=js"
export * from "./MDMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba44de",
  null
  
)

export default component.exports